export interface IZoomControlsProps {
    currentZoom: number;
    onZoom: (zoom: number) => void;
    min: number; max: number;
    absolutePos?: boolean;
}

const ZoomControls = (props: IZoomControlsProps) => {
    return (
        <div style={{position: props.absolutePos ? "absolute" : "fixed", userSelect: "none", bottom: 40, left: 20, display: "flex", flexDirection:"column"}}>
            <button onClick={(e) => {
                let zoom = props.currentZoom - .10;
                if (zoom < props.min) zoom = props.min;
                props.onZoom(zoom);
            }}>+</button>
            <button onClick={(e) => {
                let zoom = props.currentZoom + .10;
                if (zoom > props.max) zoom = props.max;
                props.onZoom(zoom);
            }}>-</button>
        </div>
    );
};

export default ZoomControls;